<template>
<div>
    <v-dialog v-model="aprDialog" max-width="1200px" scrollable>
        <v-card>
          <v-card-title class="headline">
            Agency Procurement Request<small class="ml-2">[{{aprData.PRCODE || aprData.PRCCODE}}]</small>
            <v-spacer></v-spacer>
            <v-btn icon @click="clickCloseMainDialog()"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
          <v-card-text style="max-height: 900px;">
            <v-form @submit.prevent ref="formRefAPR">
            <v-row class="mt-1">
              <v-col cols="12">
                <v-data-table
                  v-model="aprFormData.Lists"
                  :loading="loading"
                  :headers="headers"
                  :items="itemList"
                  :options.sync="options"
                  item-key="ppmpItemID"
                  show-select
                  @toggle-select-all="selectAllToggle"
                  :items-per-page="-1"
                  :footer-props="{
                    'items-per-page-options': [-1]
                  }"
                  class="elevation-1"
                >
                  <template v-slot:top>
                    
                  </template>
                  <template v-slot:[`item.Qty`]="{ item }">
                    <span class="text-no-wrap">{{ formatQty(item.Qty || 0) }}</span>
                  </template>
                  <template v-slot:[`item.UnitCost`]="{ item }">
                    <span class="text-no-wrap">₱ {{ formatPrice(item.UnitCost || 0) }}</span>
                  </template>
                  <template v-slot:[`item.Amount`]="{ item }">
                    <span class="text-no-wrap">₱ {{formatPrice(parseFloat(item.UnitCost) * parseFloat(item.Qty))}}</span>
                  </template>
                  <template v-slot:[`item.APRQty`]="{ item }">
                    <v-edit-dialog
                    :return-value.sync="item.APRQty"
                    large
                  >
                    <span class="text-no-wrap" :style="'color: ' + ((parseFloat(item.Qty) * parseFloat(item.UnitCost)) < (parseFloat(item.APRQty) * parseFloat(item.APRUnitCost)) ? 'red' : 'green')">{{ formatQty(item.APRQty) }}</span>
                    <template v-slot:input>
                      <v-text-field v-model="item.APRQty" :rules="[formRules.required, formRules.numberRequired, (parseFloat(item.Qty) * parseFloat(item.UnitCost)) >= (parseFloat(item.APRQty) * parseFloat(item.APRUnitCost))]">
                      </v-text-field>
                    </template>
                  </v-edit-dialog>
                  </template>
                  <template v-slot:[`item.APRUnitCost`]="{ item }">
                    <v-edit-dialog
                    :return-value.sync="item.APRUnitCost"
                    large
                  >
                    <span class="text-no-wrap" :style="'color: ' + ((parseFloat(item.Qty) * parseFloat(item.UnitCost)) < (parseFloat(item.APRQty) * parseFloat(item.APRUnitCost)) ? 'red' : 'green')">₱ {{ formatPrice(item.APRUnitCost) }}</span>
                    <template v-slot:input>
                      <v-text-field v-model="item.APRUnitCost" :rules="[formRules.required, formRules.numberRequired, (parseFloat(item.Qty) * parseFloat(item.UnitCost)) >= (parseFloat(item.APRQty) * parseFloat(item.APRUnitCost))]">
                      </v-text-field>
                    </template>
                  </v-edit-dialog>
                  </template>
                  <template v-slot:[`item.APRAmount`]="{ item }">
                    <span class="text-no-wrap font-weight-bold" :style="'color: ' + ((parseFloat(item.Qty) * parseFloat(item.UnitCost)) < (parseFloat(item.APRQty) * parseFloat(item.APRUnitCost)) ? 'red' : 'green')">₱ {{formatPrice(parseFloat(item.APRUnitCost || 0) * parseFloat(item.APRQty || 0))}}</span>
                  </template>
                  <template v-slot:[`item.QtyRemaining`]="{ item }">
                    {{parseFloat(item.Qty) - parseFloat(item.IARQTY)}}
                  </template>
                  <template v-slot:[`item.Status`]="{ item }">
                    <v-icon v-if="item.PRstatus == 2 || item.PRstatus >= 3" color="header">mdi-check-circle</v-icon>
                    <v-icon v-else color="amber darken-2">mdi-close-circle</v-icon>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="mt-5">
            <v-switch
                  v-model="switchAPR"
                  v-if="showEditAPR"
                  inset
                  class="mb-4"
                  hide-details
                  color="header"
                  label="Edit Mode"
                ></v-switch>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-2" outlined @click="clickCloseMainDialog()">Cancel</v-btn>
            <v-btn color="blue darken-2 white--text" @click="confirmGenerateAPR()" :loading="isLoading"><v-icon>mdi-printer</v-icon>Print</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <v-dialog v-model="dialogSave" max-width="500px">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <div class="mx-6">
          Are you sure you want to save the APR?
        </div>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" outlined @click="dialogSave = false">Cancel</v-btn>
          <v-btn color="#E45200" class="white--text" @click="saveAPRConfirm()"><v-icon>mdi-check</v-icon> Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
    </div>
</template>
    
    <script>
      export default {
	props : {
        aprData: {},
	},
        data: () => ({
          headers: [
              {
                text: 'Item Name',
                align: 'start',
                sortable: false,
                value: 'ItemName',
              },
              { text: 'Description', value: 'itemDescription' , style: 'max-width: 200px;', sortable: false },
              { text: 'Unit Measure', value: 'UnitMeasureDescription', align: "center", sortable: false},
              { text: 'Qty', value: 'Qty', align: "center", sortable: false },
              { text: 'Unit Cost', value: 'UnitCost', align: "end", sortable: false},
              { text: 'Total Amount', value: 'Amount', align: "end", sortable: false},
              { text: 'Qty (APR)', value: 'APRQty', align: "center", sortable: false },
              { text: 'Unit Cost (APR)', value: 'APRUnitCost', align: "end", sortable: false},
              { text: 'Total Amount (APR)', value: 'APRAmount', align: "end", sortable: false},
              { text: 'APR Status', value: 'Status', align: "center", sortable: false}
            ],
          headersAPR: [
              {
                text: 'Item No',
                align: 'center',
                sortable: false,
                value: 'ItemNo',
              },
              {
                text: 'Quantity',
                align: 'center',
                sortable: false,
                value: 'Qty',
              },
              {
                text: 'Unit Cost',
                align: 'end',
                sortable: false,
                value: 'UnitCost',
              },
              {
                text: 'Amount',
                align: 'end',
                sortable: false,
                value: 'Amount',
              },
              // { text: 'Unit Measure', align: 'center', value: 'UnitMeasureDescription' , sortable: false},
              { text: 'Item Name', value: 'ItemName', sortable: false },
              { text: 'Item Description', value: 'ItemDescription', sortable: false }
            ],
          loading: false,
          prViewItemDialog: false,
           footerProps: {'items-per-page-options': [5, 10, 20, 50, 100, 500]},
           options: {},
          isLoading: false,
          fadeAwayMessage: {
            show: false,
            type: "success",
            header: "Successfully Added!",
            message: "",
            top: 10,
          },
          aprDialog: false,
          aprFormData: {
          APRType: null,
          dodID: null,
          podID: null,
          Lists: []
          },
          dodList: [],
          podList: [],
          switchAPR: false,
          showEditAPR: false,
          itemList: [],
          expanded2: [],
          totalCount: 0,
          dialogDelete: false,
          dialogSave: false,
          disabledCount: 0
        }),
       watch: {
          aprData: {
            handler (data) {
            if(data.PRID){
            if(data.APRType != null && data.dodID != null){
              this.aprFormData.APRType = data.APRType.toString()
              this.aprFormData.dodID = data.dodID
              this.aprFormData.podID = data.podID
              this.showEditAPR = true;
              this.switchAPR = false;
            }
            else{
              this.showEditAPR = false;
              this.switchAPR = true;
            }
            this.aprDialog = true;
            this.getItems();
            }
            },
            deep: true,
          },
        },
        created(){
          this.getDOD();
          const self = this;
          this.itemList.map(item => {
            if (item.disabled) self.disabledCount += 1
          })
        },
        methods: {

        clickCloseMainDialog () {
            this.aprFormData = {
              APRType: null,
              dodID: null,
              podID: null,
              Lists: []
              }
            this.itemList =[];
            this.aprDialog = false;
            this.eventHub.$emit('closeAPRModal', false);
        },
          getItems () {
            let data = new FormData();
               data.append('PRID', this.aprData.PRID);
                  this.axiosCall(
                  '/pr/apr/items',
                  'POST',
                  data
              )
              .then((res) => {
                this.loading = false;
                this.itemList = res.data.data.result;
                this.itemList.forEach(item => {
                  item.APRQty = item.APRQty ? this.formatQty(item.APRQty) : this.formatQty(item.Qty);
                  item.APRUnitCost = item.APRUnitCost ? parseFloat((item.APRUnitCost)).toFixed(2) : parseFloat(item.UnitCost).toFixed(2);
                });
                this.aprFormData.Lists = this.itemList
                this.selectAllToggle({items: this.itemList, value: true})
                this.selectAllToggle({items: this.itemList, value: false})
              })
          },
          getDOD(){
            this.axiosCall("/get/all/POUtil", "POST", []).then((res) => {
              this.dodList = res.data.data.dod;
              this.podList = res.data.data.pod;
            });
          },
          selectAllToggle(props) {
            if(this.aprFormData.Lists.length != this.itemList.length - this.disabledCount) {
              this.aprFormData.Lists = [];
              const self = this;
              props.items.forEach(item => {
                if(!item.disabled) {
                  self.aprFormData.Lists.push(item);
                } 
              });
            } else this.aprFormData.Lists = [];
          },
          confirmGenerateAPR(){
            if(this.$refs.formRefAPR.validate()){
              let items = [];
              this.aprFormData.Lists.forEach(item => {
              if(typeof item.ppmpItemID === 'string'){
              let ppmpItemIDs = item.ppmpItemID.split(',');
                ppmpItemIDs.forEach(pi_id => {
                  items.push(pi_id)
                });
              }
              else{
                items.push(item.ppmpItemID)
              }
              });
              console.log(items)
              this.isLoading = true;
              let data = new FormData();
              let url = '';
              if(this.aprData.PRCID){
                data.append('PRCID', this.aprData.PRCID);
                data.append('PRIDs', this.aprData.PRID);
                url = '/prc/generateAPR';
              }
              else{
                data.append('PRID', this.aprData.PRID);
                url = '/pr/generateAPR';
              }
              // data.append('APRType', this.aprFormData.APRType);
              // data.append('dodID', this.aprFormData.dodID);
              // data.append('podID', this.aprFormData.podID);
              data.append('items', JSON.stringify(this.aprFormData.Lists));
                          this.axiosCall(
                        url,
                        'POST',
                        data
                    )
                    .then((res) => {
                        this.isLoading = false;
                        if(res.data.status) {
                        let recanvass = 0;
                        if(this.aprData.IsRecanvassed == 1){
                          recanvass = 1;
                        }
                        this.getItems();
                        if(this.aprData.PRCID){
                          window.open(this.apiUrl + "/prc/apr/" + JSON.stringify(items) + '/' + res.data.data);
                        }
                        else{
                          window.open(this.apiUrl + "/pr/apr/" + recanvass + '/' + JSON.stringify(items) + '/' + res.data.data);
                        }
                        // this.$refs.aprFormData.reset();
                        // this.aprDialog = false;
                        // this.initialize();
                        }else {
                        this.fadeAwayMessage.show = true;
                        this.fadeAwayMessage.type = 'error';
                        this.fadeAwayMessage.message = res.data.message;
                        this.fadeAwayMessage.header = 'System Message';
                        }
                    })
              }
              else{
                this.isLoading = false;
                this.fadeAwayMessage.show = true;
                this.fadeAwayMessage.type = 'error';
                this.fadeAwayMessage.message = "Unable to proceed. Please check the information you've entered and try again.";
                this.fadeAwayMessage.header = 'System Message';
              }
          },
        }
      }
    </script>
        
    <style scoped>
    .v-dialog--fullscreen, .prModal {
      overflow-x: hidden !important;
    }
    </style>